export const getObjectDataFromJSON = (dataString) => {
    if (!dataString) {
        return {};
    }

    return (typeof dataString === 'string')
        ? JSON.parse(dataString)
        : dataString;
};
